import capitalize from 'lodash/capitalize'

export const GENDERS = {
  M: 'Man',
  F: 'Woman',
  androgyne: 'Androgyne',
  androgynous: 'Androgynous',
  bigender: 'Bigender',
  demiboy: 'Demiboy',
  demifemale: 'Demifemale',
  demigirl: 'Demigirl',
  demiguy: 'Demiguy',
  demimale: 'Demimale',
  demiman: 'Demiman',
  demiwoman: 'Demiwoman',
  enby: 'Enby',
  female_to_male: 'Female to Male',
  gender_fluid: 'Gender Fluid',
  gender_neutral: 'Gender Neutral',
  gender_nonconforming: 'Gender Nonconforming',
  gender_questioning: 'Gender Questioning',
  gender_variant: 'Gender Variant',
  genderqueer: 'Genderqueer',
  intersex: 'Intersex',
  intersex_man: 'Intersex Man',
  intersex_person: 'Intersex Person',
  intersex_woman: 'Intersex Woman',
  male_to_female: 'Male to Female',
  neither: 'Neither',
  neutrois: 'Neutrois',
  non_binary: 'Non-binary',
  non_gendered: 'Non-Gendered',
  other: 'Other',
  pangender: 'Pangender',
  polygender: 'Polygender',
  third_gender: 'Third Gender',
  trans: 'Trans',
  trans_man: 'Trans Man',
  trans_person: 'Trans Person',
  transfeminine: 'Transfeminine',
  transgender: 'Transgender',
  transgender_female: 'Transgender Female',
  transgender_male: 'Transgender Male',
  transgender_man: 'Transgender Man',
  transgender_person: 'Transgender Person',
  transgender_woman: 'Transgender Woman',
  transmasculine: 'Transmasculine',
  transsexual: 'Transsexual',
  transsexual_female: 'Transsexual Female',
  transexual_male: 'Transexual Male',
  transexual_man: 'Transexual Man',
  transsexual_person: 'Transsexual Person',
  transsexual_woman: 'Transsexual Woman',
  two_spirit: 'Two-Spirit',
  hijra: 'Hijra',
  agender: 'Agender',
}
export const PREFERENCES = {
  M: 'Men',
  F: 'Women',
  non_binary: 'Non-binary',
  everyone: 'Everyone',
}

const USER_SEXUAL_ORIENTATION = {
  STRAIGHT: 'straight',
  GAY: 'gay',
  LESBIAN: 'lesbian',
  BISEXUAL: 'bisexual',
  ALLOSEXUAL: 'allosexual',
  ANDROSEXUAL: 'androsexual',
  ASEXUAL: 'asexual',
  AUTOSEXUAL: 'autosexual',
  BICURIOUS: 'bicurious',
  DEMISEXUAL: 'demisexual',
  FLUID: 'fluid',
  GRAYSEXUAL: 'graysexual',
  GYNESEXUAL: 'gynesexual',
  MONOSEXUAL: 'monosexual',
  OMNISEXUAL: 'omnisexual',
  PANSEXUAL: 'pansexual',
  POLYSEXUAL: 'polysexual',
  QUEER: 'queer',
  QUESTIONING: 'questioning',
  SKOLIOSEXUAL: 'skoliosexual',
  SPECTRASEXUAL: 'spectrasexual',
  PREFER_NOT_TO_SAY: 'prefer_not_to_say',
  NOT_LISTED: 'not_listed',
}

const USER_SEXUAL_ORIENTATION_LABELS = {
  [USER_SEXUAL_ORIENTATION.PREFER_NOT_TO_SAY]: 'Prefer Not To Say',
  [USER_SEXUAL_ORIENTATION.NOT_LISTED]: 'Not Listed',
}
export const OTHER_GENDER = 'Other-Gender'

export const GENDER_OPTIONS = Object.entries(GENDERS).map(([value, label]) => ({ value, label }))
export const PREFERENCE_OPTIONS = Object.entries(PREFERENCES).map(([value, label]) => ({
  value,
  label,
}))

export const SEXUALITY_OPTIONS = Object.entries(USER_SEXUAL_ORIENTATION).map(([_, value]) => ({
  value,
  label: USER_SEXUAL_ORIENTATION_LABELS[value] || capitalize(value),
}))

export const BIRTHDATE_FORMAT = 'yyyy-MM-dd'
